import { render, staticRenderFns } from "./trasl.vue?vue&type=template&id=783629b3&"
import script from "./trasl.vue?vue&type=script&lang=js&"
export * from "./trasl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports